import styled from 'styled-components';

import { Video } from '@sorare/core/src/atoms/ui/Video';
import { breakpoints, tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const NotScrollable = styled.div`
  height: calc(var(--100vh) - var(--current-stack-height));
  overflow: hidden;

  /* HACK to remove the scrolling due to AppLayout bottom padding for mobile navbar height */
  margin-bottom: calc(-1 * var(--navbar-height-mobile));
  @media ${tabletAndAbove} {
    margin-bottom: 0;
  }
`;

export const RivalsSquadComingSoon = () => {
  const src =
    'https://frontend-assets.sorare.com/videos/coming_soon_squad_desktop.mp4';
  const mobileSrc =
    'https://frontend-assets.sorare.com/videos/coming_soon_squad_mobile.mp4';

  return (
    <NotScrollable>
      <Video
        loop
        muted
        autoPlay
        playsInline
        sources={[
          {
            src: mobileSrc,
            media: `(max-width: ${breakpoints.tablet}px)`,
          },
          {
            src,
            media: `(min-width: ${breakpoints.tablet}px)`,
          },
        ]}
      />
    </NotScrollable>
  );
};
